import { isEqual } from 'lodash';
import { IFilterComparator, RatingsFilterModel } from '../../filter-types';

export class RatingsFilterModelComparator
  implements IFilterComparator<RatingsFilterModel> {
  applyFilterOptions() {
    // do nothing
  }

  hasValidDiff(
    grid: Partial<RatingsFilterModel>,
    store: RatingsFilterModel
  ): boolean {
    if (!grid) {
      return true;
    }
    if (
      isEqual(grid.minValue, store.minValue) &&
      isEqual(grid.maxValue, store.maxValue) &&
      isEqual(grid.isFilterActive, store.isFilterActive) &&
      isEqual(grid.radio, store.radio) &&
      isEqual(grid.ratingsRadio, store.ratingsRadio)
    ) {
      return false;
    }

    return true;
  }
}
